export const imageTextComputed = {
  computed: {
    mediaElStyles() {
      const { corners } = this.module.config.media;
      const styles = {
        flex: !this.isColumnLayout ? 3 : null,
        borderRadius:
          corners.value === "round"
            ? "var(--cr-border-radius-medium)"
            : "initial",
      };

      return styles;
    },
    textElStyles() {
      const { textColor } = this.module.config.text;
      const styles = {
        flex: !this.isColumnLayout ? 1 : null,
        color: textColor.value,
      };

      return styles;
    },
  },
};
